// Descontos progressivos
(function () {
  'use strict';

  if ($('.form-promocoes').length > 0) {
    const $listDescontos = $('[data-list="descontos"]');
    const $btnAddDescontos = $('#add-descontos');
    const descItemsValue = $('input[name="desc_items_json"]').val();
    const listDescontosArr = [];
    const acao_form = $('input[name="acao"]').attr('value');

    const htmlLine = (item = {}) => {
      const nextID = formListGenerateID($listDescontos);
      const quantidade = item?.quantidade || 0;
      const porcentagem = item?.porcentagem || 0;
      return `
      <tr data-label="Porcentagem:" data-item="${nextID}">
        <td>
          <span># ${nextID}</span>
        </td>
        <td>
          <div class="input-group">
            <input type="text" name="desc_items[${nextID}][porcentagem]" inputmode="numeric" class="form-control percent" data-input-default="0" data-parsley-trigger="change" placeholder="0" value="${porcentagem}" >
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </td>
        <td data-label="Quantidade:">
          <div class="form-group ct_taxa_form-group mw">
            <div class="input-group number-spinner">
              <div class="input-group-prepend">
                <button class="btn btn-default ns-sub" type="button"><i class="las la-minus"></i></button>
              </div>
              <input type="text" inputmode="numeric" name="desc_items[${nextID}][quantidade]" value="${quantidade}" class="form-control ns-input" min="1" data-parsley-trigger="change">
              <div class="input-group-append">
                <button class="btn btn-default ns-add" type="button"><i class="las la-plus"></i></button>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="table-options no-hover">
            <button type="button" href="#" class="btn btn-danger btn-rem btn-rem-sm" data-rem="${nextID}" data-toggle="tooltip" data-placement="bottom" title="Remover"><i class="las la-trash"></i></button>
          </div>
        </td>
      </tr>
    `;
    };

    // Insert
    if (acao_form == 'insert') {
      formListAdd($listDescontos, htmlLine());
    }

    if (acao_form == 'update') {
      // Popula items na lista
      try {
        const descItemsJson = JSON.parse(descItemsValue);
        descItemsJson.forEach((item) => {
          formListAdd($listDescontos, htmlLine(item));
        });
      } catch (e) {
        console.log(e);
      }

      if ($listDescontos.find('tr').length == 0) {
        formListAdd($listDescontos, htmlLine());
      }
    }

    // Removendo linha
    $listDescontos.on('click', '[data-rem]', removeDescontoLinha);
    function removeDescontoLinha(ev) {
      ev.preventDefault();
      const $btnRemove = $(ev.target.closest('[data-rem]'));
      const rowID = $btnRemove.data('rem');
      formListDel($listDescontos, rowID);
    }

    // Adicionando linha
    $btnAddDescontos.on('click', addLineDesconto);
    function addLineDesconto(ev) {
      formListAdd($listDescontos, htmlLine());
    }
  }
})();

// Controla os campos das informações
(function () {
  'use strict';

  if ($('.form-promocoes').length > 0) {
    // Variáveis
    const $campoTipoDesconto = $('input[name="tipo"]');
    const $campoValorWrp = $('.valor_desconto_wrp');
    const $campoValor = $('#valor_desconto');
    const $campoPorcentagemWrp = $('.porcentagem_desconto_wrp');
    const $campoPorcentagem = $('#porcentagem_desconto');
    const $campoLimitarUsos = $('#limitar_usos');
    const $campoLimiteUsosWrp = $('.limite_usos_wrp');
    const $campoLimiteUsos = $('#limite_usos');
    const $campoLimitarDatas = $('#limitar_datas');
    const $campoLimiteDatasWrp = $('.limite_datas_wrp');
    const $campoDataInicio = $('#data_inicio');
    const $campoDataFim = $('#data_fim');

    $campoTipoDesconto.on('change', handleTipoDesconto);
    $campoLimitarUsos.on('change', handleLimiteUsos);
    $campoLimitarDatas.on('change', handleLimiteDatas);

    // Ao alterar o tipo de desconto
    handleTipoDesconto();
    function handleTipoDesconto() {
      if ($('input[name="tipo"]:checked').val() == 'valor') {
        $campoPorcentagemWrp.hide();
        $campoPorcentagem.prop('required', false);
        $campoValorWrp.show();
        $campoValor.prop('required', true);
      } else {
        $campoPorcentagemWrp.show();
        $campoPorcentagem.prop('required', true);
        $campoValorWrp.hide();
        $campoValor.prop('required', false);
      }
    }

    // Ao alterar se haverá limite de usos
    handleLimiteUsos();
    function handleLimiteUsos() {
      if ($campoLimitarUsos.is(':checked')) {
        $campoLimiteUsosWrp.show();
        $campoLimiteUsos.prop('disabled', false);
        $campoLimiteUsos.prop('required', true);
      } else {
        $campoLimiteUsosWrp.hide();
        $campoLimiteUsos.prop('disabled', true);
        $campoLimiteUsos.prop('required', false);
      }
    }

    // Ao alterar se haverá limite de datas
    handleLimiteDatas();
    function handleLimiteDatas() {
      if ($campoLimitarDatas.is(':checked')) {
        $campoLimiteDatasWrp.show();
        $campoDataInicio.prop('disabled', false);
        $campoDataInicio.prop('required', true);
        $campoDataFim.prop('disabled', false);
        $campoDataFim.prop('required', true);
      } else {
        $campoLimiteDatasWrp.hide();
        $campoDataInicio.prop('disabled', true);
        $campoDataInicio.prop('required', false);
        $campoDataFim.prop('disabled', true);
        $campoDataFim.prop('required', false);
      }
    }
  }
})();
